import { Component } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-password-changed',
  template: '',
  standalone: false
})
export class PasswordChangedComponent {
  constructor(public auth: AuthService) {
    sessionStorage.removeItem('redirect_uri');
    this.auth.forceLogin(false);
  }
}
